import React from "react";
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import synergy_logo_black from "../../assets/img/synergy_logo_black.png";

//If position fixed add width 100%
const BottomBorder = styled.div`
    // position: absolute;
    // bottom: 0;
    display: flex;
    align-items: center;
    background-color: white;
    border-bottom: 5px solid ${Theme.color['green-deloitte']};
    border-top: 1px solid ${Theme.color['neutral-3']};
    // margin-top: auto;
    padding: 0px 0px 0px 64px;
    width: -webkit-fill-available;
    height: 105px;
    min-height: 105px;
`;

const Image = styled.img`
    width: ${props => (props.$width)}px;
    height: ${props => (props.$height)}px;
`;

export const Footer = () => {
    return (
        <BottomBorder>
            <Image src={synergy_logo_black} $width={120} $height={60} alt='AdEPorto logo' />
        </BottomBorder>
    )
};